import EnergiaSolarPerguntasFrequentes from '../components/templates/EnergiaSolarPerguntasFrequentes';

export default function EnergiaSolarPerguntasFrequentesPage() {
  return <EnergiaSolarPerguntasFrequentes />;
}
